import React, { useState, useEffect, useCallback } from 'react';
import { useStyles } from './_utility';
import { useStore } from '../../zustand';
import QRCode from 'qrcode.react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
const BUCKET_URL_INDEX = process.env.REACT_APP_BUCKET_URL_INDEX;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const QRCodePrompt = () => {
//   const dynamic_text_settings = useStore.getState().dynamic_text_settings;
  const { dynamic_text_settings } = useStore.getState().store_settings;
  const classes = useStyles(dynamic_text_settings);
  const [open, setOpen] = React.useState(true);
  const [qrURL, setQrURL] = useState('');
  const variant_id = useStore.getState().variant_id;
  const { product_session_id, variant_session_id, variant_type } = useStore.getState().settings;
  const actions = useStore(state => state.actions);

  const generateLink = useCallback(() => {
    let redirectURL;
    if(variant_type === 'bco') {
        redirectURL = `${BUCKET_URL_INDEX}?variant=${variant_type}_${variant_id}&variant_session_id=${variant_session_id}&product_session_id=${product_session_id}&origin=external`;
    } else {
        redirectURL = `${BUCKET_URL_INDEX}?variant=${variant_id}&variant_session_id=${variant_session_id}&product_session_id=${product_session_id}&origin=external`;
    }
    
    setQrURL(redirectURL)
  }, [variant_id, variant_session_id, product_session_id, variant_type]);

  useEffect(() => {
    generateLink();
  }, [generateLink])

  const handleClose = () => {
    setOpen(false)
    setTimeout(() => {
      actions.handleModalDisplay({ display: '', status: false })
    }, 750)
  };


  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="dispay-qr-code"
        aria-describedby="dispay-qr-code-modal"
        open={open}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        hideBackdrop={true}
        className={classes.root}
        TransitionComponent={Transition}
      >
        <section className={classes.modalTitleDebut}>
          <h6>You're moments away from Augmented Reality</h6>
        </section>
        <MuiDialogContent dividers className={classes.root}>
          <section className={classes.modalBody}>
            <div className={classes.qrCode}>
              <section className={classes.qrBorder}>
                <section className="QRborder-inner">
                {
                  (qrURL.length > 0) ? (
                    <QRCode
                      value={qrURL}
                      size={250}
                      width={250}
                      level={"H"}
                      includeMargin={true}
                    />
                  ) : (<div></div>)
                }
                </section>
              </section>
            </div>
          </section>
        </MuiDialogContent>
        <section className={classes.modalFooter}>
          <p className={classes.modalCopyDebut}>
            Scan this QR code with your phone's camera
          </p>
        </section>
      </Dialog>
    </div>
  );
}

export default QRCodePrompt;
